import { render, staticRenderFns } from "./LetterEdit.vue?vue&type=template&id=6b79936f&scoped=true&"
import script from "./LetterEdit.vue?vue&type=script&lang=js&"
export * from "./LetterEdit.vue?vue&type=script&lang=js&"
import style0 from "./LetterEdit.vue?vue&type=style&index=0&id=6b79936f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79936f",
  null
  
)

export default component.exports